import React, { Component } from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"

import Resources from "../../resources/mlp-resources.json"
import { useSiteContent } from "../hooks/use-site-content"

const WhoTitle = styled.span`
  font-family: var(${Resources.who_are_we.title.font});
  font-size: ${Resources.who_are_we.title.size};
  color: var(${Resources.who_are_we.title.color});
  text-transform: uppercase;
  text-align: center;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    font-size: ${Resources.who_are_we.title.size_small};
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    font-size: ${Resources.who_are_we.title.size_med};
  }
`

const WhoText = styled.span`
  font-family: var(${Resources.who_are_we.text.font});
  font-size: ${Resources.who_are_we.text.size};
  color: var(${Resources.who_are_we.text.color});
  text-align: center;
  width: 100%;
  margin: 0 auto;

  line-height: 1.7em;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    font-size: ${Resources.who_are_we.text.size_small};
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    font-size: ${Resources.who_are_we.text.size_med};
  }
`

const WhoTextContainer = styled.div`
  margin-top: 20px;
`

const WhoListContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2em;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr;
  }
`

const FeatureCard = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 24px 24px 20px 24px;
  text-align: left;
  font-weight: bold;
  border: 1px solid var(--primary-light-color);
`

const FeatureText = styled.span`
  display: block;
  font-family: var(${Resources.who_are_we.title.font});
  font-size: ${Resources.who_are_we.text.size};
  color: var(--primary-color);
  line-height: 1.7em;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    font-size: ${Resources.who_are_we.text.size_small};
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    font-size: ${Resources.who_are_we.text.size_med};
  }
`

const ColorfulSection = styled.div`
  background-color: var(--primary-color);

  display: grid;
  grid-template-columns: 6fr 4fr;

  margin-top: 6em;

  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-rows: 4.5fr 5fr;
  }
`

const StyledBgDiv = styled(BackgroundImage)`
  @media only screen and (max-width: 767px) {
    grid-row: 1;
    margin-bottom: -10%;
  }
`

const ColorfulTextHolder = styled.div`
  text-align: center;

  @media only screen and (min-width: 1401px) {
    max-width: 40em;
    text-align: right;
    justify-self: end;
    width: 100%;
    padding: 6vh 6vw;
    text-align: center;
    margin: 6vh 4em 6vh 8vw;
  }

  @media only screen and (min-width: 992px) and (max-width: 1400px) {
    padding: 8vh 8vw;
  }
  @media only screen and (max-width: 991px) {
    padding: 8vh 8vw;
  }
`

const ColorfulText = styled.span`
  font-family: var(${Resources.who_are_we.colorful.font});
  font-size: ${Resources.who_are_we.colorful.size};
  color: var(${Resources.who_are_we.colorful.color});
  display: block;
  margin-top: 40px;
  span {
    text-align: center;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    font-size: ${Resources.who_are_we.colorful.size_small};
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    font-size: ${Resources.who_are_we.colorful.size_med};
  }
`

class WhoAreWe extends Component {
  render() {
    const {
      about_us: { banner_label },
    } = this.props.siteContent

    const features = [
      "Más de 10 años de experiencia en infraestructura aeroportuaria",
      "Experiencia en proyectos de inversión pública y privada",
      "Conocimiento en normatividad nacional e internacional (Ley de Aeropuertos, OACI, CODA, COSA)",
      "Integración de aspectos técnicos, financieros, jurídicos, ambientales y regulatorios",
    ]
    return (
      <div id="WhoAreWeSection">
        <div className="container">
          <WhoTitle>{Resources.who_are_we.title.label}</WhoTitle>
          <WhoTextContainer>
            <WhoText>
              Fundada en 2007 en la Ciudad de México
              <br />
              Más de 18 años de experiencia en proyectos de inversión,
              concesiones e infraestructura
              <br />
              Enfoque integral: técnico, financiero y legal.
            </WhoText>
          </WhoTextContainer>
        </div>
        <ColorfulSection>
          <ColorfulTextHolder>
            <WhoListContainer>
              {features.map((feature, index) => (
                <FeatureCard key={index}>
                  <FeatureText>{feature}</FeatureText>
                </FeatureCard>
              ))}
            </WhoListContainer>
            <ColorfulText dangerouslySetInnerHTML={{ __html: banner_label }} />
          </ColorfulTextHolder>
          <StaticQuery
            query={graphql`
              query {
                colorfulBkg: file(name: { eq: "banner_img" }) {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 839, maxHeight: 681) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                  }
                }
              }
            `}
            render={data => (
              <StyledBgDiv
                Tag={"div"}
                className={"bg-whoarewe"}
                fluid={[data.colorfulBkg.childImageSharp.fluid]}
                backgroundColor={`var(${Resources.cover.bg_color})`}
              ></StyledBgDiv>
            )}
          />
        </ColorfulSection>
      </div>
    )
  }
}

export default props => {
  const SiteContent = useSiteContent()
  return <WhoAreWe siteContent={SiteContent} {...props} />
}
